import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { withRouter } from 'react-router'
import ReactGA from "react-ga4"
import getWidgetsOrigin from '../getWidgetsOrigin'
import getStrings from 'getStrings'
import getLanguage from 'getLanguage'
import AppContext from 'core/appContext'
import { CardElement } from "@stripe/react-stripe-js";
import { createStripeIntent, createStripeSubscriptionFromIntent } from "../../Uluweb";
import qs from "qs";

const ERRORS = {
    en: {
        GENERIC_ERROR: 'Our servers encountered an error.',
        INVALID_USER: 'Your session has expired.',
        SUBSCRIPTION_ALREADY_EXISTS: 'You account is already linked to a subscription.',
    },
    fr: {
        GENERIC_ERROR: 'Nos serveurs ont rencontré une erreur.',
        INVALID_USER: 'Votre session est expirée.',
        SUBSCRIPTION_ALREADY_EXISTS: 'Votre compte est déjà lié a un abonnement.'
    }
}

class WidgetsStripeForm extends React.Component {

    constructor(props) {
        super(props)

        const parentOrigin = getWidgetsOrigin()
        if (!parentOrigin)
            console.error('No origin found!')
        else
            console.log('parentOrigin: ', parentOrigin)

        const { token, priceID } = qs.parse(window.location.search, { ignoreQueryPrefix: true })

        if (!token)
            console.error('No token found!')
        else
            console.log('widget token: ', token)

        if (!priceID)
            console.error('No priceID found!')
        else
            console.log('widget priceID: ', priceID)

        this.state = {
            parentOrigin: parentOrigin,
            token: token,
            priceID: priceID,
            loading: false,
            message: '',
        }

    }

    componentDidMount() {
        // eslint-disable-next-line no-undef
        gtag('get', process.env['REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID'], 'client_id', (clientID) => {
            this.setState({googleClientID: clientID})
        })
    }

    subscribeClicked = async (event) => {
        event.preventDefault()

        const strings = getStrings()

        const { stripe, elements } = this.props

        if (!stripe) {
            console.log('Stripe is null')
            return
        }
        if (!elements) {
            console.log('elements is null')
            return
        }
        if (!this.state.token) {
            console.log('Token is missing!')
            return
        }
        if (!this.state.parentOrigin) {
            alert('Invalid parent origin!')
            return
        }

        window.fbq('trackCustom', 'StartPurchasingCustom', {
            content_name: 'Starting The Subscription Process',
            status: 'Success'
        })

        try {
            // ****** Ask backend to create SetupIntent ******
            this.setState({ loading: true, message: strings.STRIPE_SUBSCRIBE_MESSAGE_PREPARE });
            const responseIntent = await createStripeIntent(this.state.token, 'widget')
            if (!responseIntent?.data?.success) {
                console.log('responseIntent?.data: ', responseIntent?.data)
                throw new Error(responseIntent?.data?.error)
            }
            const { clientSecret, customerID } = responseIntent.data
            console.log(`customerID: ${customerID}`)


            // ****** Confirm card details (may trigger 3DS popup) ******
            this.setState({ message: strings.STRIPE_SUBSCRIBE_MESSAGE_CARD_AUTH });
            const resultCardConfirm = await stripe.confirmCardSetup(clientSecret, { payment_method: { card: elements.getElement(CardElement) } })
            if (resultCardConfirm.error) {
                console.log('resultCardConfirm: ',resultCardConfirm)
                throw new Error(resultCardConfirm.error.message)
            }
            const paymentMethodID = resultCardConfirm.setupIntent.payment_method;
            console.log(`paymentMethodID: ${paymentMethodID}`)


            // ****** Tell backend to create the subscription ******
            this.setState({ message: strings.STRIPE_SUBSCRIBE_MESSAGE_CREATING })
            const responseSubscription = await createStripeSubscriptionFromIntent(this.state.token, customerID, paymentMethodID, this.state.priceID)
            if (!responseSubscription?.data?.success) {
                console.log('responseSubscription?.data: ', responseSubscription?.data)
                throw new Error(responseSubscription?.data?.error)
            }
            const { subscriptionID } = responseSubscription.data
            console.log(`subscriptionID: ${subscriptionID}`)

            if (!subscriptionID) {
                throw new Error()
            }

            this.setState({ message: strings.STRIPE_SUBSCRIBE_MESSAGE_SUCCESS })

            window.parent.postMessage(
                {
                    type: "Subscription_SUCCESS",
                    subscriptionID: subscriptionID
                },
                this.state.parentOrigin
            )
        } catch (err) {
            if (err?.message === 'SUBSCRIPTION_ALREADY_EXISTS' ||
                err?.message === 'INVALID_USER' ||
                err?.message === 'INVALID_PAYLOAD')
                // Prevent further actions by the user for these errors.
                this.setState({ loading: true, message: '' })
            else
                this.setState({ loading: false, message: '' })

            this.displayError(err?.message ?? err)

            window.parent.postMessage(
                {
                    type: "Subscription_ERROR",
                    message: err?.message
                },
                this.state.parentOrigin
            )
        }
    }

    displayError = (errorCode) => {
        const language = getLanguage()
        if (!errorCode || Object.keys(errorCode).length === 0) {
            console.error('stripe.displayError: generic: ', errorCode)
            return alert(ERRORS[language].GENERIC_ERROR)
        }

        console.error(`stripe.displayError: ${errorCode}`)
        alert(ERRORS[language].hasOwnProperty(errorCode) ? ERRORS[language][errorCode] : ERRORS[language]['GENERIC_ERROR'])
    }

    render() {
        const strings = getStrings()

        return (
            <div className='form-box'>
                <form id='formSubscribe'>

                    <div style={{
                        border: "1px solid #ccc",
                        padding: "12px",
                        marginTop: "20px",
                        marginBottom: "20px",
                        borderRadius: "4px"
                    }}>
                        <CardElement
                            options={{
                                hidePostalCode: true,
                                style: {
                                    base: {
                                        fontSize: "20px",
                                        color: "#32325d",
                                    },
                                },
                            }}
                        />
                    </div>

                    <button
                        data-form='formSubscribe'
                        onClick={this.subscribeClicked.bind(this)}
                        disabled={this.state.loading}
                        className="form-button"
                        type='submit'
                        style={{ backgroundColor: '#FF9408' }}
                    >
                        {this.state.loading ? strings.GENERIC_PROCESSING : strings.STRIPE_SUBSCRIBE_BUTTON}
                    </button>
                    <p>{this.state.message}</p>
                </form>
            </div>
        )
    }
}

WidgetsStripeForm.contextType = AppContext

export default withRouter(WidgetsStripeForm)